import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PopUp from '@precis-digital/kurama/PopUp';
import Typography from '@precis-digital/kurama/Typography';
import Label from '@precis-digital/kurama/Label';
import Input from '@precis-digital/kurama/Input';
import Toggle from '@precis-digital/kurama/Toggle';
import Button from '@precis-digital/kurama/Button';
import Divider from '@precis-digital/kurama/Divider';
import { StyledCautionCard, StyledUpperText, StyledLeaveWorkspacePopupFooter, StyledPasswordInput, StyledTextSpan, StyledCautionText, StyledConfirmationBlock } from '../Popup/styles';
import { type PopupProps } from './types';
import { handleConfirmationChange } from './utils';
import { useDeleteClient } from 'src/workspace/api';
import { useCurrentClient } from 'shared/context/ClientContext';
import { useTranslation } from 'shared/translations';
import manAtCampfire from 'public/assets/images/man_at_campfire.png';
import ThemedImage from 'shared/components/Themed/Image';
import { makeToastWithLoading } from 'shared/components/Toaster';
import { APP_ROUTES } from 'shared/routes';
import { useChangePath } from 'shared/components/Router';
const CONFIRMATION_DELETE_WORD = 'DELETE';
const DeleteWorkspacePopup = props => {
  const $ = _c(79);
  const {
    open,
    onClose
  } = props;
  const {
    changePath
  } = useChangePath();
  const {
    currentClient,
    clearCachedClient
  } = useCurrentClient();
  const [deleteInputValue, setDeleteInputValue] = useState("");
  const [confirmConditions, setConfirmConditions] = useState(false);
  const hasManuallyConfirmedToLeave = deleteInputValue === CONFIRMATION_DELETE_WORD;
  const leaveInputColor = hasManuallyConfirmedToLeave ? "success" : "error";
  const {
    t
  } = useTranslation("workspace");
  const {
    mutate: deleteClient
  } = useDeleteClient();
  let t0;
  if ($[0] !== changePath || $[1] !== clearCachedClient || $[2] !== currentClient.id || $[3] !== currentClient.name || $[4] !== deleteClient) {
    t0 = async () => {
      const {
        toastOnSuccess,
        toastOnError
      } = makeToastWithLoading();
      deleteClient({
        clientId: currentClient.id
      }, {
        onSuccess: () => {
          toastOnSuccess(`Successfully deleted the workspace '${currentClient.name}'.`);
          changePath(APP_ROUTES.workspace.listPage).then(() => {
            clearCachedClient();
          });
        },
        onError: () => {
          toastOnError("An unknown error occurred while trying to delete the workspace");
        }
      });
    };
    $[0] = changePath;
    $[1] = clearCachedClient;
    $[2] = currentClient.id;
    $[3] = currentClient.name;
    $[4] = deleteClient;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const handleDeleteClient = t0;
  let t1;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ThemedImage src={manAtCampfire.src} width={544} height={179} alt="man at campfire" style={{
      maxWidth: "100%",
      height: "auto"
    }} />;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== t) {
    t2 = t("titles.deleteWorkspacePopup");
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== currentClient.name || $[10] !== t2) {
    t3 = <StyledUpperText><Typography variant="h2">{" "}{t2} {currentClient.name}?</Typography></StyledUpperText>;
    $[9] = currentClient.name;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Label color="error" text="Warning" />;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t) {
    t5 = t("descriptions.cautionBold");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t5) {
    t6 = <StyledTextSpan> {t5} </StyledTextSpan>;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t) {
    t7 = t("descriptions.caution");
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <StyledCautionCard>{t4}<StyledCautionText variant="h4">{t6}{t7}</StyledCautionText></StyledCautionCard>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t("titles.confirmDeleteWorkspace");
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <Typography variant="h3"> {t9} </Typography>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t) {
    t11 = t("titles.typeDelete");
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <Typography variant="body2">{t11}</Typography>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== deleteInputValue || $[31] !== leaveInputColor) {
    t13 = deleteInputValue !== "" ? {
      color: leaveInputColor
    } : null;
    $[30] = deleteInputValue;
    $[31] = leaveInputColor;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = e => {
      handleConfirmationChange(e, CONFIRMATION_DELETE_WORD, setDeleteInputValue);
    };
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== deleteInputValue || $[35] !== t13) {
    t15 = <Input name="leave" value={deleteInputValue} {...t13} onChange={t14} />;
    $[34] = deleteInputValue;
    $[35] = t13;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t12 || $[38] !== t15) {
    t16 = <StyledPasswordInput>{t12}{t15}</StyledPasswordInput>;
    $[37] = t12;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Divider />;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t) {
    t18 = t("descriptions.understandingDeleteWorkspace");
    $[41] = t;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18) {
    t19 = <Typography variant="body1">{t18}</Typography>;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== confirmConditions) {
    t20 = () => {
      setConfirmConditions(!confirmConditions);
    };
    $[45] = confirmConditions;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== confirmConditions || $[48] !== t20) {
    t21 = <Toggle onChange={t20} defaultChecked={false} checked={confirmConditions} />;
    $[47] = confirmConditions;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== t19 || $[51] !== t21) {
    t22 = <StyledConfirmationBlock>{t19}{t21}</StyledConfirmationBlock>;
    $[50] = t19;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <Divider />;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("buttons.cancel");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  let t25;
  if ($[56] !== onClose || $[57] !== t24) {
    t25 = <Button onClick={onClose} scheme="light" variant="outlined">{t24}</Button>;
    $[56] = onClose;
    $[57] = t24;
    $[58] = t25;
  } else {
    t25 = $[58];
  }
  let t26;
  if ($[59] !== handleDeleteClient) {
    t26 = () => {
      handleDeleteClient();
    };
    $[59] = handleDeleteClient;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  const t27 = !(confirmConditions && hasManuallyConfirmedToLeave);
  let t28;
  if ($[61] !== t) {
    t28 = t("buttons.deleteWorkspacePopup");
    $[61] = t;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t26 || $[64] !== t27 || $[65] !== t28) {
    t29 = <Button onClick={t26} scheme="light" variant="semantic-destructive" disabled={t27}>{t28}</Button>;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  let t30;
  if ($[67] !== t25 || $[68] !== t29) {
    t30 = <StyledLeaveWorkspacePopupFooter>{t25}{t29}</StyledLeaveWorkspacePopupFooter>;
    $[67] = t25;
    $[68] = t29;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== onClose || $[71] !== open || $[72] !== t10 || $[73] !== t16 || $[74] !== t22 || $[75] !== t3 || $[76] !== t30 || $[77] !== t8) {
    t31 = <div><PopUp open={open} handleOpen={onClose}>{t1}{t3}{t8}{t10}{t16}{t17}{t22}{t23}{t30}</PopUp></div>;
    $[70] = onClose;
    $[71] = open;
    $[72] = t10;
    $[73] = t16;
    $[74] = t22;
    $[75] = t3;
    $[76] = t30;
    $[77] = t8;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  return t31;
};
export default DeleteWorkspacePopup;